export default "__VITE_ASSET__iA332Bwa__"